/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "@mui/styled-engine-sc";
import FormLabel from "@mui/material/FormLabel";
import React from "react";

const StyledFormLabel = styled(({ ...props }) => <FormLabel {...props} />)`
  ${({ theme }) => `
  `}
`;

export { StyledFormLabel };
